<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div>
          <div class="container">
            <div class="main-golfClubStatus">
              <div class="golfClubStatus-header">
                <h3 class="title">
                  <div class="item">
                    {{ $t('cd001.title') }}
                  </div>
                </h3>
                <div class="date">
                  <div class="item">
                    {{ nowTime }}
                  </div>
                </div>
              </div>
              <div class="golfClubStatus-body">
                <div class="select">
                  <div class="contain">
                    <div class="title">
                      {{ $t('cd001.regionClubStatus', { region: locationName }) }}
                    </div>
                    <div class="content">
                      <div class="formSelect" ref="select01">
                        <div class="formSelectList" @click="openSelect01">
                          <input
                            type="text"
                            v-model="locationName"
                            :placeholder="$t('cd001.regionPlaceholder')"
                            readonly
                          />
                        </div>
                        <div class="formSelectPopup select01">
                          <div class="formSelectPopup-container">
                            <div class="outer">
                              <div class="inner">
                                <div class="formSelectPopup-box">
                                  <div class="formSelectPopup-zone">
                                    <div class="formSelectPopup-header">
                                      <input
                                        type="text"
                                        :placeholder="$t('cd001.selectRegionPlaceholder')"
                                      />
                                    </div>
                                    <ul class="formSelectPopup-body">
                                      <li
                                        v-for="locations in locationArr"
                                        :key="locations.name"
                                      >
                                        <label>
                                          <input
                                            type="radio"
                                            v-model="selectedLocation"
                                            :value="locations.code"
                                            v-on:change="confirmSelect01()"
                                          />
                                          <input type="checkbox" />
                                          <i></i>
                                          <span>{{ locations.name }}</span>
                                        </label>
                                      </li>
                                    </ul>
                                    <div class="formSelectPopup-footer">
                                      <button class="formSelectPopup-cancel">
                                        {{ $t('common.cancel') }}
                                      </button>
                                      <!-- 비활성(Attribute) : disabled -->
                                      <button class="formSelectPopup-confirm">
                                        {{ $t('common.confirm') }}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="golfClubStatusInfo">
                  <ul class="list">
                    <li class="operation">
                      <div class="contain">
                        <div class="title">
                          {{ $t('cd001.operation') }}
                        </div>
                        <div class="content">
                          {{ setupSum }}
                        </div>
                      </div>
                    </li>
                    <li class="batteryCharge">
                      <div class="contain">
                        <div class="title">
                          {{ $t('cd001.needCharge') }}
                        </div>
                        <div class="content">
                          {{ needChargedSum }}
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="golfClubStatusData scroll-body">
                  <!-- 데이터 없을때(Class) : none -->
                  <div
                    class="body dev_headerLine"
                    :class="setupSum ? '' : 'none'"
                  >
                    <div class="table thead">
                      <!-- 헤더 고정 활성(Class) : active / x축 스크롤 이동 값(Style) : x축 스크롤 이동한 값 만큼 margin-left 마이너스 값 -->
                      <div class="fixed grid" style="margin-left: -0px;">
                        <div class="contain">
                          <table class="dev_aplList">
                            <colgroup>
                              <col class="club" />
                              <col class="course" />
                              <col class="normal" />
                              <col class="abnormal" />
                              <col class="holiday" />
                              <col class="normalOperationRate" />
                              <col class="batteryCharge" />
                              <col class="spareParts" />
                              <col class="remark" />
                              <col class="pin" />
                              <col class="pinChangeSystem" />
                            </colgroup>
                            <thead>
                              <tr>
                                <th
                                  class="sort club name"
                                  @click="headerSort('name')"
                                >
                                  <div class="item">
                                    {{ $t('common.golfClub') }}
                                  </div>
                                </th>
                                <th
                                  class="sort course nhole"
                                  @click="headerSort('nhole')"
                                >
                                  <div class="item">
                                    {{ $t('common.course') }}
                                  </div>
                                </th>
                                <th
                                  class="sort normal activeCount"
                                  @click="headerSort('activeCount')"
                                >
                                  <div class="item">
                                    {{ $t('cd001.normal') }}
                                  </div>
                                </th>
                                <th
                                  class="sort abnormal inactiveCount"
                                  @click="headerSort('inactiveCount')"
                                >
                                  <div class="item">
                                    {{ $t('cd001.abnormal') }}
                                  </div>
                                </th>
                                <th
                                  class="sort abnormal holidayHoleCount"
                                  @click="headerSort('holidayHoleCount')"
                                >
                                  <div class="item">
                                    {{ $t('cd001.closedHole') }}
                                  </div>
                                </th>
                                <th class="normalOperationRate">
                                  <div class="item">
                                    {{ $t('cd001.normalOperationRate') }}
                                  </div>
                                </th>
                                <th
                                  class="sort batteryCharge needCharged"
                                  @click="headerSort('needCharged')"
                                >
                                  <div class="item">
                                    {{ $t('cd001.needCharge') }}<span>{{ $t('cd001.needChargeThreshold') }}</span>
                                  </div>
                                </th>
                                <th class="spareParts">
                                  <div class="item">
                                    {{ $t('cd001.spareParts') }}
                                  </div>
                                </th>
                                <th class="remark">
                                  <div class="item">
                                    {{ $t('cd001.remark') }}
                                  </div>
                                </th>
                                <th class="pin">
                                  <div class="item">
                                    {{ $t('cd001.pinSize') }}
                                  </div>
                                </th>
                                <th class="pinChangeSystem">
                                  <div class="item">
                                    {{ $t('cd001.pinChangeMethod') }}
                                  </div>
                                </th>
                              </tr>
                            </thead>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="table tbody">
                      <div class="contain">
                        <table>
                          <colgroup>
                            <col class="club" />
                            <col class="course" />
                            <col class="normal" />
                            <col class="abnormal" />
                            <col class="holiday" />
                            <col class="normalOperationRate" />
                            <col class="batteryCharge" />
                            <col class="spareParts" />
                            <col class="remark" />
                            <col class="pin" />
                            <col class="pinChangeSystem" />
                          </colgroup>
                          <tbody>
                            <tr
                              v-for="clubBatteryInfo in MonitoringData"
                              :key="clubBatteryInfo.ccode"
                              @click="setCcodeMoveMenu(clubBatteryInfo.ccode)"
                              style="cursor: pointer;"
                            >
                              <td class="club">
                                {{ clubBatteryInfo.name }}
                              </td>
                              <td class="course">
                                {{ clubBatteryInfo.nhole }}
                              </td>
                              <td class="normal">
                                {{ clubBatteryInfo.activeCount }}
                              </td>
                              <td class="abnormal">
                                {{ clubBatteryInfo.inactiveCount }}
                              </td>
                              <td class="holiday">
                                {{ clubBatteryInfo.holidayHoleCount }}
                              </td>
                              <!-- 0건 일때 : none -->
                              <td class="normalOperationRate">
                                {{
                                  Percentage(
                                    clubBatteryInfo.activeCount,
                                    clubBatteryInfo.setupCount
                                  )
                                }}
                              </td>
                              <!-- 0건 일때 : none -->
                              <td class="batteryCharge">
                                {{ clubBatteryInfo.needCharged }}
                              </td>
                              <td class="spareParts">
                                {{ clubBatteryInfo.idleCount }}
                              </td>
                              <td class="remark">
                                {{ clubBatteryInfo.uniqueness }}
                              </td>
                              <td class="pin">
                                {{ pinSizeCalc(clubBatteryInfo.pin_size) }}
                              </td>
                              <td class="pinChangeSystem">
                                {{ clubBatteryInfo.pin_change }}
                              </td>
                            </tr>
                          </tbody>
                          <tbody class="none">
                            <tr>
                              <td colspan="10">
                                {{ $t('cd001.noData') }}
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <th class="club">
                                {{ $t('cd001.sum') }}
                              </th>
                              <th class="course">
                                {{ nHoleSum }}
                              </th>
                              <th class="normal">
                                {{ activeSum }}
                              </th>
                              <th class="abnormal">
                                {{ inactiveSum }}
                              </th>
                              <th class="holiday">
                                {{ holidayHoleSum }}
                              </th>
                              <th class="normalOperationRate">
                                {{ perAverage }}
                              </th>
                              <th class="batteryCharge">
                                {{ needChargedSum }}
                              </th>
                              <th class="spareParts"></th>
                              <th class="remark"></th>
                              <th class="pin"></th>
                              <th class="pinChangeSystem"></th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div class="formSelectPopup select01">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select01">
                  <div class="formSelectPopup-header">
                    <input type="text" :placeholder="$t('cd001.searchPlaceholder')" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="locations in locationArr" :key="locations.name">
                      <label>
                        <input
                          type="radio"
                          v-model="selectedLocation"
                          :value="locations.code"
                          v-on:change="confirmSelect01()"
                        />
                        <input type="checkbox" />
                        <i></i>
                        <span>{{ locations.name }}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      {{ $t('common.cancel') }}
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNowTimeFullYear } from '../../util/nowTime'
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'

import { ammService, settingService, userService } from '../../router'

export default {
  name: 'CD001',
  data() {
    return {
      beforeConfirm: true,
      alertBodyHTML: '',
      callback: null,
      sortColumn: '',
      sortType: '',
      MonitoringDataByRegion: {
        aplStatsClub: [],
        clubInfoList: []
      },
      MonitoringData: [],
      searchValue: '',
      regionCode: '',
      nHoleSum: 0,
      activeSum: 0,
      inactiveSum: 0,
      perAverage: 0,
      setupSum: 0,
      needChargedSum: 0,
      locationId: '',
      locationName: '',
      selectedLocation: '',
      locationArr: [
        { name: this.$t('cd001.regionAll'), code: '0' },
        { name: this.$t('cd001.regionGyeonggiIncheon'), code: '1' },
        { name: this.$t('cd001.regionChungbuk'), code: '10' },
        { name: this.$t('cd001.regionChungnam'), code: '11' },
        { name: this.$t('cd001.regionJeolla'), code: '20' },
        { name: this.$t('cd001.regionGyeongbuk'), code: '30' },
        { name: this.$t('cd001.regionGyeongnam'), code: '31' },
        { name: this.$t('cd001.regionGangwon'), code: '40' },
        { name: this.$t('cd001.regionJeju'), code: '50' }
      ],
      nowTime: null,
      holidayHoleSum: 0
    }
  },
  created: function() {
    userService.getAll().then(response => {
      this.userInfo = response.data
      if (this.getCurrentLocationIdParam()) {
        this.locationId = this.getCurrentLocationIdParam()
      } else {
        this.locationId = '0'
      }
      this.locationName = this.locationArr.find(
        it => it.code === this.locationId
      ).name
      this.selectedLocation = this.locationId
    })
  },
  mounted: function() {
    this.setData()
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  methods: {
    setData: function() {
      ammService
        .getSummaryAplData2(this.searchValue)
        .then(response => {
          this.MonitoringDataByRegion = response.data
          this.resetData()
          this.nowTime = getNowTimeFullYear()
        })
        .catch(error => {
          console.log('getSummaryAplData2.err.===>', error)
        })
    },
    resetData: function() {
      this.allAplList = Object.keys(this.MonitoringDataByRegion.inactiveClub)
        .map(club => {
          const [ccode, name] = club.split('_')
          if (name === 'null') return false
          const holes = this.MonitoringDataByRegion.inactiveClub[club]
          const { idleCount, nhole, setupCount } = holes[0]
          return {
            ccode,
            name,
            holes,
            idleCount,
            nhole,
            setupCount
          }
        })
        .filter(club => club)
      this.MonitoringDataByRegion.clubInfoList.forEach(item => {
        const dataPath = this.allAplList.find(
          it => it.ccode.toString() === item.ccode
        )
        if (
          this.setRegionCode(item.ccode, item.region_code) ===
            Number(this.locationId) ||
          this.locationId === '0'
        ) {
          if (!dataPath) return

          // Find statsClub by ccode.
          const foundStatsClub = this.MonitoringDataByRegion.aplStatsClub.find(
            ({ ccode }) => ccode == item.ccode
          )

          const offClub = this.isTodayOff(item)
          const holidayHoles = item.holiday_holes || ''
          const holidayHolesArr = holidayHoles.split(',')
          const workHoles = dataPath.holes.filter(
            hole =>
              !offClub || !holidayHolesArr.includes(String(hole.hlidx + 1))
          )
          const normalHolesCount = workHoles.filter(hole => hole.isActive)
            .length
          const __inactiveCount__ = workHoles.length - normalHolesCount

          dataPath.needCharged = workHoles.filter(
            hole => hole.rowBattery
          ).length
          // dataPath.activeCount = workHoles.filter(hole => hole.isActive).length
          dataPath.activeCount = foundStatsClub.activeCount
          dataPath.inactiveCount = __inactiveCount__ || 0
          dataPath.setupCount = workHoles.length
          dataPath.holidayHoleCount = dataPath.holes.length - workHoles.length
          this.MonitoringData.push({ ...item, ...dataPath })
          this.needCharged = dataPath.needCharged
          this.nHoleSum += dataPath.nhole
          this.activeSum += dataPath.activeCount
          this.inactiveSum += dataPath.inactiveCount
          this.setupSum += dataPath.setupCount
          this.holidayHoleSum += dataPath.holidayHoleCount
          this.perAverage = this.Percentage(this.activeSum, this.setupSum)
          this.needChargedSum += this.needCharged
        }
      })
      this.sortColumn = 'name'
      this.sortType = 'asc'
      this.MonitoringData.sort(this.ascSort)
    },
    setCcodeMoveMenu: function(ccode) {
      localStorage.setItem('currentCcode', ccode)
      this.moveMenu('/CD002?ccode=' + ccode)
    },
    getCurrentLocationIdParam: function() {
      let currentLocationId = localStorage.getItem('CurrentLocationId')
      if (currentLocationId) {
        return currentLocationId
      } else {
        localStorage.setItem('CurrentLocationId', '1')
        return currentLocationId
      }
    },
    setSearchValue: function() {
      this.searchValue = this.regionCode
      this.setData()
    },
    headerSort: function(target) {
      if (
        document.querySelector('.dev_aplList thead tr th.ascending') !== null
      ) {
        document
          .querySelector('.dev_aplList thead tr th.ascending')
          .classList.remove('ascending')
      }
      if (
        document.querySelector('.dev_aplList thead tr th.descending') !== null
      ) {
        document
          .querySelector('.dev_aplList thead tr th.descending')
          .classList.remove('descending')
      }
      if (this.sortColumn === target) {
        if (this.sortType === 'asc') {
          this.sortType = 'desc'
          document
            .querySelector('.dev_aplList thead tr th.' + target)
            .classList.add('descending')
          this.MonitoringData.sort(this.descSort)
        } else {
          this.sortType = 'asc'
          document
            .querySelector('.dev_aplList thead tr th.' + target)
            .classList.add('ascending')
          this.MonitoringData.sort(this.ascSort)
        }
      } else {
        document
          .querySelector('.dev_aplList thead tr th.' + target)
          .classList.add('ascending')
        this.sortColumn = target
        this.sortType = 'asc'
        this.MonitoringData.sort(this.ascSort)
      }
    },
    sendAlarmAbnormalStatus(status, funcId) {
      settingService
        .sendPushAbnormalStatus({ status: status, funcId: funcId })
        .then(response => {
          if (response.statusCode === 200) {
            this.beforeConfirm = false
            this.openAlert(this.$t('cd001.sent'), null)
          } else {
          }
        })
    },
    confirmSendAlarm: function(status, funcId) {
      let targetMessage =
        status === 'isActive'
          ? this.$t('cd001.targetCommError')
          : status === 'lowBattery' // eslint-disable-next-line
          ? this.$t('cd001.targetLowBattery') // eslint-disable-next-line
          : ''
      this.beforeConfirm = true
      this.alertBodyHTML = this.$t('cd001.confirmSendAlarm', { target: targetMessage })
      this.openAlert(this.alertBodyHTML, function() {
        this.sendAlarmAbnormalStatus(status, funcId)
      })
    },
    openAlert: function(html, cb = null) {
      this.alertBodyHTML = html
      this.callback = cb
      document.querySelector('body.type-content').classList.add('alertActive')
    },
    closeAndCancelAlert: function() {
      this.alertBodyHTML = ''
      document
        .querySelector('body.type-content')
        .classList.remove('alertActive')
      if (this.callback === null) return
      this.callback = null
    },
    closeAlert: function() {
      this.alertBodyHTML = ''
      document
        .querySelector('body.type-content')
        .classList.remove('alertActive')
      if (this.callback === null) return
      this.callback()
      this.callback = null
    },
    pinSizeCalc: function(pinSize) {
      return this.confirmPinSize(pinSize)
    },
    confirmSelect01: function() {
      this.locationId = this.selectedLocation
      this.locationName = this.locationArr.find(
        it => it.code === this.selectedLocation
      ).name
      localStorage.setItem('CurrentLocationId', this.locationId)
      this.MonitoringData = []
      this.nHoleSum = 0
      this.activeSum = 0
      this.inactiveSum = 0
      this.perAverage = 0
      this.setupSum = 0
      this.needChargedSum = 0
      this.resetData()
      this.closeSelectAll()
    },
    Percentage: function(data, sum) {
      return this.calcPercentage(data, sum)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/clubdashboard/CD001.vue